import { formatContentPage } from '@/utils/formatData';

const contentful = require('contentful');

// Contentful space Playground
const client = contentful.createClient({
  space: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN,
  host: process.env.VUE_APP_CONTENTFUL_HOST,
  environment: process.env.VUE_APP_CONTENTFUL_ENVIRONMENT,
});

// Contentful space Swish.nu
const faqClient = contentful.createClient({
  space: process.env.VUE_APP_FAQ_CONTENTFUL_SPACE_ID,
  accessToken: process.env.VUE_APP_FAQ_CONTENTFUL_ACCESS_TOKEN,
  host: process.env.VUE_APP_CONTENTFUL_HOST,
  environment: process.env.VUE_APP_CONTENTFUL_ENVIRONMENT,
});

const getStartPageName = (identifier) =>
  identifier === 'api' ? 'Start page - API Reference' : 'Start page - Documentation';

export const getPageBySlug = async (slug) => {
  try {
    const contentPageReq = client.getEntries({
      content_type: 'contentPage',
      select: 'sys.id,sys.contentType,fields',
      'fields.slug': slug,
      include: 4,
    });

    const collectionPageReq = client.getEntries({
      content_type: 'collectionPage',
      select: 'sys.id,sys.contentType,fields',
      'fields.slug': slug,
      include: 3,
    });

    const customerCasePageReq = client.getEntries({
      content_type: 'customerCasePage',
      select: 'sys.id,sys.contentType,fields',
      'fields.slug': slug,
      include: 3,
    });

    const contentPage = await contentPageReq;
    const collectionPage = await collectionPageReq;
    const customerCasePage = await customerCasePageReq;

    if (contentPage.items.length) {
      return formatContentPage(contentPage.items[0]);
    }

    if (collectionPage.items.length) {
      return collectionPage.items[0];
    }

    if (customerCasePage.items.length) {
      return customerCasePage.items[0];
    }

    return null;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getApiRefPage = async (slug) => {
  try {
    const apiRefPage = await client.getEntries({
      content_type: 'apiReferencePage',
      'fields.slug[in]': slug,
      include: 6,
    });

    return apiRefPage.items[0] ? apiRefPage.items[0] : null;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getStartPage = async (identifier) => {
  const name = getStartPageName(identifier);

  try {
    const resp = await client.getEntries({
      content_type: 'startPage',
      select: 'sys.id,fields.teasers,fields.note,fields.heading,fields.introduction',
      'fields.name[in]': name,
      include: 2,
    });

    return resp.items[0] ? resp.items[0] : null;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getPageFromType = async (type) => {
  try {
    const contactPage = await client.getEntries({
      content_type: type,
      select: 'sys.id,fields',
      include: 3,
    });

    return contactPage.items[0] ? contactPage.items[0] : null;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getChangelogPosts = async () => {
  try {
    const contactPage = await client.getEntries({
      content_type: 'changelogPost',
      select: 'sys.id,fields',
    });

    return contactPage.items || null;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getFooter = async (identifier) => {
  const name = getStartPageName(identifier);

  try {
    const resp = await client.getEntries({
      content_type: 'startPage',
      select: 'sys.id,fields.footer',
      'fields.name[in]': name,
    });

    return resp.items[0] ? resp.items[0] : null;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getMenus = async (identifier) => {
  const name = getStartPageName(identifier);

  try {
    const resp = await client.getEntries({
      content_type: 'startPage',
      select: 'sys.id,fields.mainMenu,fields.secondaryMenu',
      'fields.name[in]': name,
      include: 5,
    });

    return resp.items[0] ? resp.items[0] : {};
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getFaq = async () => {
  try {
    const resp = await faqClient.getEntries({
      content_type: 'faqTargetGroup',
      select: 'sys.id,fields',
      'fields.type': 'developer',
      include: 2,
    });

    return resp.items[0] ? resp.items[0] : {};
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getFaqQuestion = async (slug) => {
  try {
    const resp = await faqClient.getEntries({
      content_type: 'faqQuestion',
      select: 'sys.id,fields',
      'fields.slug[in]': slug,
    });

    return resp.items[0] ? resp.items[0] : null;
  } catch (error) {
    throw new Error(error.message);
  }
};
